import {makeStyles} from '@material-ui/core'

export default makeStyles(theme => ({
  root: {
    '& .MuiButton-label': {
      flexDirection: 'column',
    },
    width: 84,
  },
  iconContainer: {},
  labelContainer: {
    fontWeight: theme.typography.fontWeightLight,
    textTransform: 'none',
  },
  danger: {
    color: theme.palette.error.main,
  },
}))
